/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import MediaViewer from './modules/media-viewer';
import AnnouncementModal from './modules/announcement-modal';

const siteInitialization = () => {
	CookieByte.init();
	AnnouncementModal.init();
	MediaViewer.init();
	Form.init();

	// let text module know that there is a table in it, so that we can ensure the correct responsiveness for the table
	$("table").parents('.bard__module.text').addClass("has-table");

	// add water animation to big hero
	$(".hero-big").ripples({
		resolution: 256,
		perturbance: 0.01,
	});
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);